import { Container, Row, Col, Form, Button, Spinner, Alert } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdPhoneIphone, MdTextsms } from 'react-icons/md'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import API from "../../api/api";
import Actions from '../../redux/actions'

import { useDispatch } from "react-redux";
export default function PhoneNumber(props) {

    const [number, setNumber] = useState('')
    const [code, setCode] = useState('')
    const [err, setErr] = useState(false)
    const [loading, setLoading] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const dispatch = useDispatch()
    const _sendCode = async (e) => {
        e.preventDefault()
        setLoading(true)
        await API.signupCode(number)
        setLoading(false)
        setSubmitted(true)
        dispatch(Actions.setSignupStep(2))

    }

    const _confirmCode = async (e) => {
        e.preventDefault()
        setLoading(true)
        const res = await API.confirmCode(code)
        if (res.err) {
            setErr(res.err)
            setLoading(false)
        } else {
            dispatch(Actions.setSignupStep(5))
        }
    }

    return (
        <Container className='p-4 text-center'>
            <Row>
                <Col md={6} className='border shadow-lg rounded mx-auto p-4'>

                    <Row>
                        <Col md={7} className='mx-auto'>
                            {!submitted && <Form className='mt-4' onSubmit={_sendCode}>
                                <p className='text-center'><MdPhoneIphone className='text-primary' size='8rem' /></p>

                                <p>Your phone number will be used for account recovery and scam alert updates. we NEVER share this with anyone</p>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    value={number}
                                    defaultCountry="US"
                                    onChange={setNumber}

                                />
                                <p><small>(Verification Required)</small></p>

                                <Button type='submit' variant='primary px-5 mt-5' disabled={loading || number?.length <= 10}>Send Confirmation Code</Button>
                                <p className='mt-3'><small>Message and Carrier Rates May Apply</small></p>

                                {loading && <div className='text-center mt-2'>
                                    <Spinner animation="border" />
                                </div>}

                                {err && <Alert variant='danger p-2 mt-2'>The Code is Invalid</Alert>}


                            </Form>}
                            {submitted &&
                                <Form className='mt-4' onSubmit={_confirmCode}>
                                    <p className='text-center'><MdTextsms className='text-primary' size='8rem' /></p>
                                    <Form.Group className="mb-3 text-start">
                                        <Form.Label className='text-start'>Confirmation Code</Form.Label>
                                        <Form.Control required type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="Code" />
                                        <Form.Text className="text-muted text-center">
                                            Code Sent to {number}
                                        </Form.Text>


                                        {loading && <div className='text-center mt-2'>
                                            <Spinner animation="border" />
                                        </div>}

                                        {err && <Alert variant='danger p-2 mt-2'>The Code is Invalid</Alert>}

                                        <div className='text-center'>
                                            <Button type='submit' variant='primary px-5 mt-5 mx-auto' disabled={loading || code.length < 6}>Confirm</Button>
                                            <br />
                                            <Button variant="link noDecoration" onClick={() => { setSubmitted(false); dispatch(Actions.setSignupStep(1)) }}>Back</Button>

                                        </div>


                                    </Form.Group>
                                </Form>}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}